// src/components/common/Header/MobileHeaderSearch.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, X } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './MobileHeaderSearch.module.css';

const MobileHeaderSearch = ({ show, onClose }) => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/orders?search=${encodeURIComponent(searchQuery)}`);
      setSearchQuery('');
      onClose();
    }
  };

  const handleClose = () => {
    setSearchQuery('');
    onClose();
  };

  if (!show) return null;

  return (
    <div className={styles.mobileSearchOverlay}>
      <div className={styles.mobileSearchContainer}>
        <form onSubmit={handleSubmit} className={styles.mobileSearchForm}>
          <Search size={20} className={styles.mobileSearchIcon} />
          <input
            type="text"
            placeholder={t('header.searchPlaceholder')}
            value={searchQuery}
            onChange={handleSearchChange}
            className={styles.mobileSearchInput}
            autoFocus
          />
          <button 
            type="button"
            className={styles.mobileSearchClose}
            onClick={handleClose}
          >
            <X size={20} />
          </button>
        </form>
        <div className={styles.searchHint}>
          <p>{t('header.mobileSearchHint')}</p>
        </div>
      </div>
    </div>
  );
};

export default MobileHeaderSearch;